<template>
  <div>
    <el-button type="danger" @click="onDelete()">削除</el-button>
    <el-button @click="onCancel">キャンセル</el-button>
    <el-button type="primary" @click="onUpdate">適用</el-button>
  </div>
</template>

<script>
export default {
  name: 'component-form-footer',
  methods: {
    onDelete: function () {
      this.$emit('delete')
    },
    onCancel: function () {
      this.$emit('cancel')
    },
    onUpdate: function () {
      this.$emit('update')
    }
  }
}
</script>

<style lang="scss" scoped>
</style>

<docs>
# component-form-footer

## description

コンポーネント編集時の削除／キャンセル／更新ボタンをラップしたコンポーネント

## usage

```
<component-form-footer @delete="deleteComponent()" @cancel="isEditing = false" @update="updateComponent()"></component-form-footer>
```

</docs>


// WEBPACK FOOTER //
// src/components/forms/ComponentFormFooter.vue